import { useEffect, useRef, useState } from 'react';

export function useOverflowObserver() {
  const nodeRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (!nodeRef.current) return;

      const parentEl = nodeRef.current.parentElement;
      if (!parentEl) return;

      const parentRect = parentEl.getBoundingClientRect();
      const childRect = nodeRef.current.getBoundingClientRect();

      const overflowX = childRect.right > parentRect.right;
      const overflowY = childRect.bottom > parentRect.bottom;

      setIsOverflowing(overflowX || overflowY);
    };

    const resizeObserver = new ResizeObserver(checkOverflow);

    if (nodeRef.current) resizeObserver.observe(nodeRef.current);
    if (nodeRef.current?.parentElement) resizeObserver.observe(nodeRef.current.parentElement);

    checkOverflow(); // Initial check

    return () => resizeObserver.disconnect();
  }, []);

  return { nodeRef, isOverflowing };
}
